import { CopyableCell } from "../../../../common/functions";
import { TableFrontOffice } from "../../../frontOffice/tools/tool";
import RVPairComponent from "./rvPairComponent";

function RVPairTabel(props: any) {
  let table = props.analysis.rvPairTable;
  let titles = Object.keys(table).filter((title, index) => !title.includes("Aggregated") && !title.includes("Total"));
  let tableData = new TableFrontOffice("Total");
  let allTotalSum: any = tableData.calculateTotal(table, "Total", "#F9F4D2", "BB Ticker", "Total");

  return (
    <div
      style={{
        width: "100%",
        overflowX: "auto",
      }}
      className=" fadeIn table-container-custom"
    >
      <table id={props.tableId} className="table table-risk">
        <tbody>
          <tr className="sticky-top">
            {props.titles.map((title: any, titleIndex: any) => {
              // Check if the title is one of the specified strings
              if (title !== "BB Ticker" && title !== "Long Security Name") {
                // Render the <td> element
                return (
                  <td key={titleIndex}>
                    {title}
                  </td>
                );
              } else {
                // If you need to keep the table structure consistent, render an empty <td>
                return (
                  <td key={titleIndex} className="wider-table-cell">
                    {title}
                  </td>
                );
              }
            })}
          </tr>
          <tr className="table-body sum-row borders" style={{ backgroundColor: `${allTotalSum["Color"]}` }}>
            {props.titles.map((title: any, index: any) => (
              <CopyableCell
                key={index}
                text={isFinite(allTotalSum[title]) && allTotalSum[title] ? allTotalSum[title].toLocaleString() : allTotalSum[title]}
                color={title.includes("Test") ? allTotalSum[title + " Color"]  && console.log(title + " Color", allTotalSum) : ""}
                type={"summary"}
              />
            ))}
          </tr>
          {titles.map((title, index) => (
            <RVPairComponent key={index} title={title} param={title} analysis={table} titles={props.titles} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
export default RVPairTabel;
